/** News, events, guest lectures and campus life. */

export const news = [
  {
    id: 'convocation-2026',
    date: '22 August 2026',
    tag: 'Convocation',
    title: 'Ninth convocation confers 1,842 degrees',
    text: 'The Governor of Haryana presented gold medals to 34 students, including three of our GPAT-2026 national top-100 rank holders.',
    image: '/assets/img/graduation.jpg',
    imageAlt: 'Graduands throwing their caps in the air at convocation',
    schools: ['pharmacy', 'medical', 'nursing', 'allied'],
  },
  {
    id: 'vedpharma-2026',
    date: '4–6 July 2026',
    tag: 'Conference',
    title: 'VedPharma 2026: international conference on translational drug delivery',
    text: 'Eleven countries, 340 abstracts, 26 invited talks and a two-day pre-conference workshop on quality-by-design formulation development.',
    image: '/assets/img/seminar-hall.jpg',
    imageAlt: 'Delegates seated at a conference session',
    schools: ['pharmacy'],
  },
  {
    id: 'serb-grant',
    date: '17 June 2026',
    tag: 'Research',
    title: '₹1.9 crore SERB grant for oral insulin nanocarrier project',
    text: 'The Centre for Nanomedicine will run a three-year programme on enteric-coated nanostructured carriers for peptide delivery.',
    image: '/assets/img/lab-microscopy.jpg',
    imageAlt: 'Researcher working at a microscope',
    schools: ['pharmacy'],
  },
  {
    id: 'stewardship',
    date: '2 June 2026',
    tag: 'Community',
    title: 'Antibiotic-stewardship drive reaches 4,300 households',
    text: 'Pharm.D and MPH students worked with local physicians across eleven adopted villages to de-prescribe 610 unnecessary antibiotic courses.',
    image: '/assets/img/pharmacist-consult.jpg',
    imageAlt: 'Pharmacist counselling a patient',
    schools: ['pharmacy', 'allied'],
  },
  {
    id: 'niper-jee',
    date: '28 May 2026',
    tag: 'Achievement',
    title: 'Nine students clear NIPER JEE 2026',
    text: 'Two secured single-digit ranks in the pharmaceutics stream. All nine accepted institute-funded M.S. (Pharm.) offers.',
    image: '/assets/img/study-group.jpg',
    imageAlt: 'Students working together at a shared table',
    schools: ['pharmacy'],
  },
  {
    id: 'assistive-camp',
    date: '9 May 2026',
    tag: 'Outreach',
    title: 'Free assistive-device camp fits 220 prostheses and braces',
    text: 'Run by the School of Allied Health Sciences with a district-administration partnership across four blocks of Gurugram district.',
    image: '/assets/img/rehab-outdoor.jpg',
    imageAlt: 'Rehabilitation session taking place outdoors',
    schools: ['allied'],
  },
  {
    id: 'mock-inspection',
    date: '21 April 2026',
    tag: 'Industry',
    title: 'Mock USFDA inspection run on the student pilot plant',
    text: 'A retired regulatory inspector audited student-run batch records for two days. Eighteen observations were raised, closed and published internally as a teaching case.',
    image: '/assets/img/blister-packs.jpg',
    imageAlt: 'Blister packs of tablets and capsules',
    schools: ['pharmacy'],
  },
  {
    id: 'nabh-reaccreditation',
    date: '14 March 2026',
    tag: 'Hospital',
    title: 'Teaching hospital clears NABH surveillance assessment',
    text: 'The 750-bed hospital retained full accreditation with two minor non-conformities, both closed within the thirty-day window.',
    image: '/assets/img/teaching-hospital.jpg',
    imageAlt: 'Exterior of the university teaching hospital',
    schools: ['medical', 'nursing'],
  },
  {
    id: 'nursing-simulation',
    date: '26 February 2026',
    tag: 'Teaching',
    title: 'Simulation ward expands to fourteen beds',
    text: 'Three additional high-fidelity manikins and a birthing simulator were commissioned for the B.Sc. Nursing pre-clinical phase.',
    image: '/assets/img/nursing-care.jpg',
    imageAlt: 'Nursing student wearing protective gloves',
    schools: ['nursing'],
  },
]

export const guestLectures = [
  {
    topic: 'Regulatory affairs',
    title: 'Reading a USFDA Form 483 without panicking',
    text: 'A walk through four real observation letters and what the responses should have said.',
    speaker: 'Ravi Prakash Menon · former Head of Quality, mid-size CDMO',
  },
  {
    topic: 'Clinical research',
    title: 'What a monitor actually looks for on a site visit',
    text: 'Source-data verification, protocol deviations and the three findings that recur on almost every visit.',
    speaker: 'Dr. Anjali Sridharan · Clinical Operations Manager, global CRO',
  },
  {
    topic: 'Pharmacovigilance',
    title: 'Causality assessment when the data are messy',
    text: 'Working through ten anonymised adverse-event narratives with the WHO-UMC and Naranjo scales.',
    speaker: 'Dr. Farida Ansari · PV Physician, safety database operations',
  },
  {
    topic: 'Hospital pharmacy',
    title: 'Therapeutic drug monitoring in renal impairment',
    text: 'Vancomycin and aminoglycoside dosing decisions taken on our own ICU cases.',
    speaker: 'Dr. Harkirat Bajwa · Consultant Nephrologist, Ved Reyan Hospital',
  },
  {
    topic: 'Digital health',
    title: 'Machine learning in ADR signal detection',
    text: 'Where disproportionality analysis fails, and what a model can and cannot add to it.',
    speaker: 'Nikhil Trehan · Data Science Lead, health analytics',
  },
  {
    topic: 'Careers',
    title: 'Medical writing as a first job: an honest account',
    text: 'What the work is really like in year one, what it pays, and which writing samples get shortlisted.',
    speaker: 'Shreya Kulkarni · Senior Medical Writer, regulatory writing team',
  },
]

export const societies = [
  { name: 'Pharmacy Debate Circle', text: 'Weekly motions on drug pricing, access and regulation.' },
  { name: 'VedReyan Research Forum', text: 'Student-run journal club and a monthly pre-print critique session.' },
  { name: 'National Service Scheme unit', text: 'Village health camps, blood donation drives and literacy work.' },
  { name: 'Sanjeevani (community outreach)', text: 'Runs screening camps in the eleven adopted villages.' },
  { name: 'Rangmanch (dramatics)', text: 'Two full productions a year, plus street theatre on public-health themes.' },
  { name: 'Swaranjali (music)', text: 'Choir and instrumental ensemble; performs at convocation and Aarohan.' },
  { name: 'Lens & Frame', text: 'Photography and film society; documents campus events and research.' },
  { name: 'Sports Council', text: 'Coordinates inter-school leagues and the annual athletics meet.' },
  { name: 'Entrepreneurship Cell', text: 'Pitch clinics and the BioNest student-founder pipeline.' },
  { name: 'Women in Health Sciences', text: 'Mentoring circle, safety advocacy and a visiting-speaker series.' },
]

export const campusEvents = [
  { name: 'Aarohan', when: 'February', text: 'The three-day annual cultural festival — 60 events, 14 visiting institutions.' },
  { name: 'Pharmacist Day', when: '25 September', text: 'Public counselling stalls, a poster competition and an alumni panel.' },
  { name: 'VedPharma', when: 'July', text: 'The school’s international pharmaceutical sciences conference.' },
  { name: 'Convocation', when: 'August', text: 'Degree conferment, gold medals and the alumni reunion weekend.' },
  { name: 'Sports Meet', when: 'November', text: 'Inter-school athletics, swimming and team events across four days.' },
  { name: 'Research Day', when: 'April', text: 'Every funded project presents a poster; undergraduates present first.' },
]

export const studentSupport = [
  {
    title: 'Named faculty mentor',
    text: 'Every batch is assigned a mentor for the full duration of the degree — the same person from admission to convocation.',
  },
  {
    title: 'Resident counselling team',
    text: 'Two full-time counsellors and a visiting clinical psychologist, with confidential self-referral and no academic record made.',
  },
  {
    title: 'Anti-ragging committee',
    text: 'Constituted under UGC regulations, with a 24×7 helpline, anonymous reporting and published action reports.',
  },
  {
    title: 'Internal complaints committee',
    text: 'Handles complaints of sexual harassment directly, bypassing the departmental chain, under the POSH Act.',
  },
  {
    title: 'Health centre',
    text: 'On campus, open 24×7, with two resident medical officers and free consultation at the teaching hospital.',
  },
  {
    title: 'Financial-hardship fund',
    text: 'A need-based fund assessed on family income, decided by a committee that does not include the student’s teachers.',
  },
]
